import React from 'react';
import './style.scss';
export const Box = ({children, id, className=''}) => {
    return <div {...{id: id || null}} className={`box ${className}`}>{children}</div>
};